import ta from 'thinkingdata-browser'

// 打点
export const sendTA = (
  type: String | 'XWEB_SHOW' | 'XWEB_CLICK' | 'XWEB_OPERATION',
  params = {}
) => {
  try {
    ta.track(type, params)
  } catch (error) {
    // console.log('ta.track error: ', error)
  }
}
